import {http, onSuccess, onFail, onSuccessWithHeaders} from './http';

export const questionGet = (roomKey, id) =>
    http.get(`/api/player/event/chatRoom/${roomKey}/message/${id}`)
        .then(onSuccess, onFail);

export const eventQuestionGet = (eventKey, id) =>
    http.get(`/api/player/event/${eventKey}/questions/${id}`)
        .then(onSuccess, onFail);
        
export const questionsGet = (eventKey, params) =>
    http.get(`/api/player/event/${eventKey}/questions`, {params})
        .then(onSuccess, onFail);

export const questionCreate = (roomKey, data) =>
    http.post(`/api/player/event/chatRoom/${roomKey}/message`, data)
        .then(onSuccessWithHeaders, onFail);

export const eventQuestionCreate = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/questions`, data)
        .then(onSuccessWithHeaders, onFail);

export const questionUpdate = (eventPassword, id, data) =>
    http.put(`/api/player/event/${eventPassword}/questions/${id}`, data)
        .then(onSuccess, onFail);

export const questionDelete = (eventPassword, id, params) =>
    http.delete(`/api/cp/event/${eventPassword}/questions/${id}`, {params})
        .then(onSuccess, onFail);

export const questionLikeToggle = (eventKey, id, rated) => (
    rated
        ? http.post(`/api/player/event/${eventKey}/questions/${id}/like`)
        : http.delete(`/api/player/event/${eventKey}/questions/${id}/like`)
    ).then(onSuccessWithHeaders, onFail);

export const questionDislikeToggle = (eventKey, id, rated) => (
    rated
        ? http.post(`/api/player/event/${eventKey}/questions/${id}/dislike`)
        : http.delete(`/api/player/event/${eventKey}/questions/${id}/dislike`)
    ).then(onSuccessWithHeaders, onFail);

export const questionLectorModal = (eventKey, eventPassword, id, sender) => (
    id > 0
        ? http.post(`/api/player/event/${eventKey}/questions/${id}/lectorModal`, {eventPassword, id, sender})
        : http.delete(`/api/player/event/${eventKey}/questions/lectorModal`, {params: {eventPassword}})
    ).then(onSuccess, onFail);
